import { FormElementHelper } from '@/utils'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
export class FormComponent extends Vue {
	getErrors() {
		const form = this.$refs['form'] as FormElement
		return FormElementHelper.getInputErrors(form)
	}

	validate() {
		const form = this.$refs['form'] as FormElement
		const isValid = form.validate()
		return isValid
	}
}

export default FormComponent
